import PropTypes from "prop-types";
import cn from "classnames";
import YouTube from "react-youtube";
import styles from "components/shared/adventures/Youtube.module.scss";

/**
 * @param {string} videoId - Youtube video ID
 * @param {string} aspectRatio - Define how video should size within layout
 * **** - [] - If omitted, video will take up 100% width and height of it's container
 * **** - [16:9] - Video will be 100% wide. Height based off 16:9 aspect ratio
 * **** - [4:3] - Video will be 100% wide. Height based off 4:3 aspect ratio
 */

export default function Youtube({
  videoId,
  aspectRatio,
  setPlayerInstance,
  className = null,
}) {
  const componentClasses = cn(
    styles.component,
    aspectRatio === "16:9" ? styles.ar_16_9 : "",
    aspectRatio === "4:3" ? styles.ar_4_3 : "",
    className
  );
  const options = {
    playerVars: {
      modestbranding: 1,
      rel: 0,
    },
  };

  function handleOnReady(e) {
    if (setPlayerInstance) {
      setPlayerInstance(e.target);
    }
  }

  return (
    <div className={componentClasses}>
      <YouTube
        className={styles.player}
        videoId={videoId}
        opts={options}
        onReady={handleOnReady}
      />
    </div>
  );
}

Youtube.propTypes = {
  videoId: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  setPlayerInstance: PropTypes.func,
  className: PropTypes.node,
};
